import { HttpFactoryService } from './http-factory.service';
import { EnhancedWithAuthHttpService } from './http-auth.service';
import { ReactQueryFactory } from '../utils';
import { IRemoveFriendRequest } from './types';
import { IHttpConfig } from '../types';

export class SentRequestService extends ReactQueryFactory<{}> {
  constructor(private httpService: EnhancedWithAuthHttpService) {
    super('sent-request');
  }

  async onDetailedRequest(): Promise<any | void | undefined> {
    throw new Error('onDetailedRequest not implemented!');
  }

  async onAllRequest() {
    const data = await this.httpService.get<any>('user-friend/sent-requests');
    return data;
  }

  async onListRequest() {
    throw new Error('onListRequest not implemented!');
  }

  async removeSentRequest({ id }: IRemoveFriendRequest): Promise<any | void> {
    return this.httpService.delete('user-friend/sent-request', { data: { id } } as IHttpConfig);
  }
}

const factory = new HttpFactoryService();
export const sentRequestService = new SentRequestService(factory.createAuthHttpService());
